import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';


export const canActivateNotFound: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const router = inject(Router);
  const path = state.url;

  if (path !== path.toLowerCase()) {
    return router.createUrlTree(
      [path.toLowerCase().replace('/cabinet', '')],
      { queryParams: route.queryParams },
    );
  }

  return true;
};
